import React, { useMemo, useState } from "react";
import { Avatar, Dropdown, Spinner } from "components/ui";
import classNames from "classnames";
import withHeaderItem from "utils/hoc/withHeaderItem";
import { useSelector, useDispatch } from "react-redux";
import { setLang } from "store/theme/themeSlice";
import { dateLocales } from "locales";
import dayjs from "dayjs";
import i18n from "i18next";

import { HiCheck } from "react-icons/hi";
import { apiChangeUserLanguage } from "services/UserService";
import useAuth from "utils/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { setItem } from "utils/safeStorage";

const languageList = [
  { label: "Türkçe", value: "tr", flag: "tr" },
  { label: "English", value: "en", flag: "us" },
];

export const LanguageSelector = ({ className, withText }) => {
  const { t } = useTranslation();
  const { authenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const locale = useSelector((state) => state.theme.locale);
  const dispatch = useDispatch();
  const selectLangFlag = useMemo(() => {
    return languageList.find((lang) => lang?.value === locale).flag;
  }, [locale]);

  const selectedLanguage = (
    <div className={classNames(className, "flex items-center")}>
      {loading ? (
        <Spinner size={20} />
      ) : (
        <Avatar
          size={24}
          shape="circle"
          src={`/img/countries/${selectLangFlag}.png`}
        />
      )}
    </div>
  );

  const onLanguageSelect = (lang) => {
    const formattedLang = lang.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    setLoading(true);
    const dispatchLang = async () => {
      i18n.changeLanguage(formattedLang);
      dispatch(setLang(lang));
      setItem("locale", lang);
      if (authenticated) {
        const success = await apiChangeUserLanguage({ language: lang });
        if (success) {
          setLoading(false);
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    dateLocales[formattedLang]()
      .then(() => {
        dayjs.locale(formattedLang);
        dispatchLang();
      })
      .catch((_) => {
        dispatchLang();
      });
  };

  return (
    <div className="flex items-center">
      {withText && <p className="text-white">{t("misc.language")}:</p>}
      <Dropdown renderTitle={selectedLanguage} placement="bottom-end">
        {languageList.map((lang) => (
          <Dropdown.Item
            className="mb-1 justify-between"
            eventKey={lang.label}
            key={lang.label}
            onClick={() => onLanguageSelect(lang?.value)}
          >
            <span className="flex items-center">
              <Avatar
                size={18}
                shape="circle"
                src={`/img/countries/${lang.flag}.png`}
              />
              <span className="ltr:ml-2 rtl:mr-2">{lang.label}</span>
            </span>
            {locale === lang?.value && (
              <HiCheck className="text-emerald-500 text-lg" />
            )}
          </Dropdown.Item>
        ))}
      </Dropdown>
    </div>
  );
};

export default withHeaderItem(LanguageSelector);
